import * as React from 'react';
import nutrition from "../../assets/icon/nutrition.gif";
import diabetes from "../../assets/icon/diabetes.gif";
import heartbeat from "../../assets/icon/heartbeat.gif";
import cholesterol from "../../assets/icon/cholesterol.gif";
import careStore from "../../store/careStore";

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Avatar from '@mui/material/Avatar';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {useEffect} from "react";

const CareHealth = () => {
  const storeData: any = careStore();
  
  useEffect(() => {
    
    return () => {
      storeData.setCareInfo('work_strength', '');
      storeData.setCareInfo('goal', '');
      storeData.setCareInfo('food', '');
    }
  }, []);
    
  // 선택 항목 클릭 이벤트
  const handleCheckedBoxes = (e :any) => {
    const targetName = e.target.name;
    let targetArr = storeData.careInfo.interest_disease === '' ? [] : storeData.careInfo.interest_disease.split(',');
    if(e.target.checked){
      targetArr.push(targetName);
    }else{
      targetArr = targetArr.filter((v :any) => v !== targetName);
    }
    storeData.setCareInfo('interest_disease', targetArr.join(','));
  };
  

  
  return (
    
    <Stack  sx={{ width: '100%',background:'#F1F2F4', minWidth:320}} spacing={2}>

      <Grid sx={{bgcolor:'#fff', p:0, pt:2,pb:3, width:'100%',minHeight:515  }}>
        <Box sx={{ boxSizing: 'border-box',}}>
        <Typography  component="div" sx={{fontSize:18,  pb:1, color:'#555', m:4, mb:0, textAlign:'center'}}>
          관심 질환을 선택해 주세요.
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row', p:1,
            margin:' 0 auto',
            boxSizing: 'border-box',
            justifyContent:'center',
            '& .MuiFormControlLabel-root': {}
          }}
    >
          <FormGroup sx={{p:0, justifyContent:"center"}} aria-label="position" row >
            <Stack flexDirection={'row'} >
              <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                <Avatar alt="" src={nutrition} sx={{m:'10px auto'}} />
                <FormControlLabel control={
                  <Checkbox onClick={handleCheckedBoxes} name="체중관리" checked={storeData.careInfo.interest_disease.includes('체중관리')}
                    icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                    
                    sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                      color: '#3ecbca',
                    },  }} />} 
                    label="체중관리"  
                    labelPlacement="top" 
                  />
              </Box>

              <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                <Avatar alt="" src={diabetes} sx={{m:'10px auto'}} />
                <FormControlLabel control={
                  <Checkbox onClick={handleCheckedBoxes} name="당뇨병" checked={storeData.careInfo.interest_disease.includes('당뇨병')}
                    icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                    
                    sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                      color: '#3ecbca',
                    },  }} />} 
                    label="당뇨병"  
                    labelPlacement="top" 
                  />
              </Box>
            </Stack>

            <Stack flexDirection={'row'}>
              <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                <Avatar alt="" src={heartbeat} sx={{ m:'10px auto'}} />
                <FormControlLabel control={
                  <Checkbox onClick={handleCheckedBoxes} name="고혈압" checked={storeData.careInfo.interest_disease.includes('고혈압')}
                    icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                    
                    sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                      color: '#3ecbca',
                    },  }} />} 
                    label="고혈압"  
                    labelPlacement="top" 
                  />
              </Box>

              <Box sx={{p:1,border:'1px solid #3ecbca', bgcolor:'#fff', m:2, width:130, borderRadius:'50%',textAlign:'center'}}>
                <Avatar alt="" src={cholesterol} sx={{ m:'10px auto'}} />
                <FormControlLabel control={
                  <Checkbox onClick={handleCheckedBoxes} name="이상지질" checked={storeData.careInfo.interest_disease.includes('이상지질')}
                    icon={<CheckCircleOutlineIcon />} checkedIcon={<CheckCircleIcon />} 
                    
                    sx={{color:'#3ecbca', '& .MuiSvgIcon-root': { fontSize: 32 },'&.Mui-checked': {
                      color: '#3ecbca',
                    },  }} />} 
                    label="이상지질"  
                    labelPlacement="top" 
                  />
              </Box>
            </Stack>

  
          </FormGroup>
        </Box>
          
        </Box>
      </Grid>

  </Stack >
     
  );
}

export default CareHealth;